export const ANALYSIS_CONTAINER_ID = 'analysis-container'

export const THEMIS_LOGOS = {
  phishing: 'themis-logo',
  safe: 'themis-logo-safe',
  spam: 'themis-logo-spam',
  unsure: 'themis-logo-unsure',
  'presumed safe': 'themis-logo-safe',
}
